import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

//buying NFT Modal
const ConfirmModal = ({
  show,
  handleCloseParent,
  handleConfirm,
  msg,
  subText,
}) => {
  const [showModal, setShowModal] = React.useState(show);

  //handle closing modal
  const handleClose = () => {
    setShowModal(false);
    handleCloseParent(false);
  };

  return (
    <>
      <Modal
        show={showModal}
        onHide={handleClose}
        scrollable={true}
        size="md"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-dark">Confirm Action</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h5 className="text-dark">{msg}</h5>
          <p className="text-dark">{subText}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn" onClick={() => handleConfirm()}>
            Ok
          </button>
          <button className="btn btn-default" onClick={handleClose}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConfirmModal;
